class ShippingCountdown extends HTMLElement {
  connectedCallback() {
    this._timeEl = this.querySelector('[data-time]');
    this._deadline = new Date(this.getAttribute('deadline'));

    if (!this._timeEl || isNaN(this._deadline)) return;

    this._tick();
    this._interval = setInterval(() => this._tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this._interval);
  }

  _tick() {
    const diff = this._deadline - Date.now();

    if (diff <= 0) {
      this._timeEl.textContent = '0h 0m 0s';
      clearInterval(this._interval);
      return;
    }

    this._timeEl.textContent = this._format(diff);
  }

  _format(ms) {
    const s = Math.floor(ms / 1000);
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;

    return `${h}h ${m}m ${sec}s`;
  }
}

customElements.define('shipping-countdown', ShippingCountdown);